export default {
  actionRelatorios ({ commit }, payload) {
    commit('setRelatorios', payload)
  },
}
